export default __webpack_public_path__ + "static/media/astro.551ece38.svg";